



export const envVariables = {
    REACT_APP_TAMANIO_DRAWER: process.env.REACT_APP_TAMANIO_DRAWER,
    REACT_APP_PAGINADO: process.env.REACT_APP_PAGINADO,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    REACT_APP_SOCKET_IO_URL: process.env.REACT_APP_SOCKET_IO_URL,
    HEADER:  process.env.REACT_APP_HEADER, 
};

